import { Injectable } from "@angular/core";
import { ICorso } from "app/shared/models/corso.interface";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceCorsiChat extends BASEMysqlService {

  prefix = 'corsi_chat_'

  //////////////////////////////////////////////////////////////////////////////////////////

  list(): Promise<any> {
    let data = {
      auth: this.getAuth(),
      
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
  }
  list_by_user(): Promise<any> {
    let data = {
      auth: this.getAuth(),
      
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'list_by_user', data).toPromise();
  }

  get(id): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
  }

  upsert(item: ICorso): Promise<any> {
    let data = {
      auth: this.getAuth(),
      item: item
    }

    return this.http.post<ICorso[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
  }

  delete(id: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
  }

}